import parseHTML from 'html-react-parser';
import { PROPS_TO_CHECK } from '../constants';

const getImageData = (otherProps, data) => {
  const imageData = {};

  PROPS_TO_CHECK.forEach(([keyData, keyProps]) => {
    const value = otherProps[keyProps] || (data && data[keyData]);
    if (keyData === 'caption') {
      imageData[keyData] = value ? parseHTML(value) : '';
      return;
    }
    imageData[keyData] = value || '';
  });

  return imageData;
};

export default getImageData;
